import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ImageGenState {
  fileName: string;
  isSaved: boolean;
  tempImagePath: string;
  prompt_type: string;
  input: string;
}

const initialState: ImageGenState = {
  fileName: 'Untitled 1',
  isSaved: false,
  tempImagePath: '',
  prompt_type: '',
  input: '',
};

const imageGenSlice = createSlice({
  name: 'imageGen',
  initialState,
  reducers: {
    setFileName: (state, action: PayloadAction<{ fileName: string }>) => {
      state.fileName = action.payload.fileName;
    },
    saveFile: (state, action: PayloadAction<{ fileSaved: boolean }>) => {
      state.isSaved = action.payload.fileSaved;
    },
    savePromptInfo: (
      state,
      action: PayloadAction<{
        tempImagePath: string;
        prompt_type: string;
        input: string;
      }>
    ) => {
      state.prompt_type = action.payload.prompt_type;
      state.tempImagePath = action.payload.tempImagePath;
      state.input = action.payload.input;
    },
  },
});

export const { setFileName, saveFile, savePromptInfo } = imageGenSlice.actions;
export default imageGenSlice.reducer;
